import Lottie from "lottie-react";
import React from "react";
import { useLocation } from "react-router";
import animationData from "../../assets/animations/no-result.json";
import "./Unauthorized.scss";

const Unauthorized: React.FC = () => {
  const location = useLocation();
  const status = (location.state as { status?: number } | null)?.status;
  const isNotFound = status === 404;

  return (
    <div className="unauthorized-page">
      <div className="unauthorized-content">
        <div className="unauthorized-animation">
          <Lottie animationData={animationData} loop={true} />
        </div>
        <h1 className="unauthorized-title">
          {isNotFound ? "Sidan hittades inte" : "Åtkomst saknas"}
        </h1>
        <p className="unauthorized-description">
          {isNotFound ? (
            "Det begärda innehållet kunde inte hittas. Kontakta support om du behöver hjälp."
          ) : (
            <>
              Du saknar behörighet att ta del av detta innehåll.
              <br />
              Vid behov, kontakta support.
            </>
          )}
        </p>
      </div>
    </div>
  );
};

export default Unauthorized;
